export const types = {
  DELETE: 'deleteMedication'
};
